import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { CMS_PAGE } from 'Component/Header/Header.config';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';

import BlackFridayTeasingPage from './BlackFridayTeasingPage.component';

import { history } from 'Route';

export const mapDispatchToProps = dispatch => ({
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
    updateMeta: meta => dispatch(updateMeta(meta)),
    setHeaderState: stateName => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName))
});

export class BlackFridayTeasingPageContainer extends PureComponent {
    componentDidMount() {
        this._removeBreadcrumbs();
        this._changeMeta();
        this._changeHeaderState();
    }

    componentDidUpdate() {
        this._changeMeta();
        this._changeHeaderState();
    }

    _removeBreadcrumbs() {
        const { toggleBreadcrumbs } = this.props;

        toggleBreadcrumbs(false);
    }
    _changeMeta() {
        const { updateMeta } = this.props;

        updateMeta({ title: 'Black Friday' });
    }
    _changeHeaderState() {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: CMS_PAGE,
            title: 'Black Friday',
            onBackClick: () => history.goBack()
        });
    }

    render() {
        return <BlackFridayTeasingPage />;
    }
}

export default connect(null, mapDispatchToProps)(BlackFridayTeasingPageContainer);
